/**
 * created by tianruojun
 * 编辑器表单布局配置项
 * 每行总宽24
 */
export const informationConfig = {
    text: 8,
    textarea: 24,
    date: 8,
    select: 8,

    default:8,
    summary:24,
    author:8,
    phone:8,
    contact:8,
    photography:8,
    camera:8,
    editor:8,
    url: '/cm-sites-pms/website/news/getExtendsField',
    showFTitle: true,
};

export const formItemSizeConfig = {
    fontSize:14,
    inputHeight:32,
    formItemHeight:{
        default:40,
        textarea:100,
        "complex-textarea":100,
        label:45,
    },
    inputSize:'default',
};
